import { FC, useContext, useMemo } from 'react';

import { Button, Dropdown, type MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

import { StepTwoFormContext } from '../../../../contexts/StepTwoForm';
import {
  GenericDataFormContext,
  QuotationInfoContext,
  QuotationStep,
} from '../../../../../../../shared';

import './index.css';

interface HeaderTabConsortiumProps {
  areTabActionsAllowed: boolean;
  id: number;
}

export const HeaderTabConsortium: FC<HeaderTabConsortiumProps> = ({
  areTabActionsAllowed,
  id,
}) => {
  const { currentStep } = useContext(QuotationInfoContext);
  const { duplicateTab, tabs, setShowModal, setKeyTabToDelete } =
    useContext(StepTwoFormContext);
  const { tabsUserCanNotDelete, userCanDeleteTabs } = useContext(GenericDataFormContext);
  
  const canNotDeleteTab = useMemo(() => tabs.length === 1 || !userCanDeleteTabs, [tabs, tabsUserCanNotDelete, id]);

  const onMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '1') {
      duplicateTab(id);
    }

    if (e.key === '2') {
      setKeyTabToDelete(id);
      setShowModal(true);
    }
  };

  const items = [
    {
      key: '1',
      label: 'Duplicar',
    },
    {
      key: '2',
      label: 'Eliminar',
      danger: true,
      disabled: canNotDeleteTab,
    },
  ];

  return (
    <>
      Consorcio {id}
      {currentStep === QuotationStep.TWO && areTabActionsAllowed && (
        <Dropdown
          menu={{ items, onClick: onMenuClick }}
          trigger={['click']}
          arrow
        >
          <Button type='text' className='header-tab-consortium-button'>
            <MoreOutlined />
          </Button>
        </Dropdown>
      )}
    </>
  );
};
